export const SET_BOARD_CALENDAR_LIST_MODE = "SET_BOARD_CALENDAR_LIST_MODE";
